import React, { useState } from 'react'
import * as UI from 'konsys-ui'
import { Select } from 'antd'
import { detailMode } from '../constants'
import { checkFloat } from '../../../utils/util-services'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
*/

// const dataSelector = (viewId, model) => _.find(model, o => o.id === viewId)

const CreateMode = ({
  data, disabled, onChangeHandler,
}) => {
  const [dropdownText, setText] = useState('กรุณาเลือก')
  switch (data.type) {
    case 0:
      return <UI.InputWithLabel {...data.props} input={{
        onChange: e => onChangeHandler(data.id, data.valueType === 'float' ? parseFloat(e.target.value) : e.target.value),
        onKeyDown: e => data.valueType === 'float' && !checkFloat(e) && e.preventDefault(),
        type: data.valueType === 'float' ? 'number' : 'text',
        step: data.valueType === 'float' ? '0.1' : undefined,
        min: '0',
      }
      }/>
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Div display='flex' flexDirection='column' margin='8px 0 0'>
        <UI.P {...data.props}>{data.label}</UI.P>
        <Select
          dropdown
          disabled={disabled}
          buttonProps={{
            disabled,
            ...data.props.buttonProps,
            text: dropdownText,
          }}
          {...data.props}
          style={{
            width: '150px',
          }}
          onChange={(e) => {
            onChangeHandler(data.id, e)
            setText(e.text)
          }}>
          {
            data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
          }
        </Select>
      </UI.Div>
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, onChangeHandler, initialData,
}) => {
  const [dropdownText, setText] = useState()
  const {
    TruckownerInfo,
  } = initialData
  switch (data.type) {
    case 0:
      return <UI.InputWithLabel {...data.props} input={
        {
          disabled,
          onChange: e => onChangeHandler(data.id, data.valueType === 'float' ? parseFloat(e.target.value) : e.target.value),
          defaultValue: TruckownerInfo[data.id] || '',
          onKeyDown: e => data.valueType === 'float' && !checkFloat(e) && e.preventDefault(),
          type: data.valueType === 'float' ? 'number' : 'text',
          step: data.valueType === 'float' ? '0.1' : undefined,
          min: '0',
        }
      }/>
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Div display='flex' flexDirection='column' margin='8px 0 0'>
        <UI.P {...data.props}>{data.label}</UI.P>
        <Select
          dropdown
          defaultValue={TruckownerInfo[data.id]}
          disabled={disabled}
          buttonProps={{
            disabled,
            ...data.props.buttonProps,
            text: dropdownText,
          }}
          {...data.props}
          style={{
            width: '150px',
          }}
          onChange={(e) => {
            onChangeHandler(data.id, e)
            setText(e.text)
          }}>
          {
            data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
          }
        </Select>
      </UI.Div>
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, disabled, selectedData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode
      data={data}
      disabled={disabled}
      selectedData={selectedData}
      onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
      mutationVariables={mutationVariables}
      />
    case detailMode.EDIT:
      return <EditMode data={data}
      disabled={disabled}
      initialData={initialData}
      onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
      mutationVariables={mutationVariables}
      />
    case detailMode.VIEW:
      return <EditMode data={data}
      disabled={true}
      initialData={initialData}
      onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
      mutationVariables={mutationVariables} />
    default:
      return <p>no mode</p>
  }
}
